<template>
	<div ref="dragVerify" class="drag_verify" :style="dragVerifyStyle" @mousemove="dragMoving" @mouseup="dragFinish" @touchmove="dragMoving" @touchend="dragFinish">
    <div class="dv_progress_bar" ref="progressBar" :style="progressBarStyle">
    </div>
    <div class="dv_text" :style="textStyle" ref="message">{{message}}</div>
    <div ref="handler" class="dv_handler dv_handler_bg" @mousedown="dragStart" :style="handlerStyle" @touchstart="dragStart">
      <i :class="handlerIcon"></i>
    </div>
  </div>
</template>
<script>
	export default{
		name:'ZJDragVerify',
		props:{
			width:{
				type:Number,
				default: 2600
			},
			height:{
				type:Number,
				default: 4.2
			},
			text:{
				type:String,
				default: '滑动解锁'
			},
			successText:{
				type:String,
				default: '验证通过'
			},
			background:{
				type:String,
				default:'#ebebeb'
			},
			progressBarBg:{
				type:String,
				default:'#5fb878'
			},
			completedBg:{
				type:String,
				default:'#66cc66'
			},
			circle:{
				type:Boolean,
				default: false
			},
			handlerIcon:{
				type:String

			},
			successIcon:{
				type:String
			},
			handlerBg:{
				type:String,
				default:'#fff'
			},
			textSize:{
				type:String,
				default:'1.14rem'
			}

		},
		computed:{
			handlerStyle:function(){
				return {
					left: '0px',
					height : this.height + 'rem',
					borderRadius: this.circle ? '50%': 0,
					background: this.handlerBg
				}
			},
			message : function(){
				return this.isPassing?this.successText:this.text
			},
			dragVerifyStyle:function(){
				return {
					// width: this.width + 'px',
					height : this.height+'rem',
					lineHeight: this.height+'rem',
					background:this.background,
					borderRadius: this.circle ? this.height/2+'rem' : '.4rem',
				}
			},
			progressBarStyle: function(){
				return {
					background: this.progressBarBg,
					height : this.height + 'rem',
					borderRadius: this.circle?this.height/2+'rem 0 0 ' + this.height/2+'rem':0
				}
			},
			textStyle: function(){
				return {
					height : this.height + 'rem',
					width : '100%',
					fontSize:this.textSize
				}
			},
			handlerIconClass: function(){
				return this.isPassing?this.handlerIcon:this.successIcon
			}

		},
		data(){
			return{
				isMoving : false,
				x:0,
				maxWidth: '' /* 拖动最大宽度，依据滑块宽度算出来的 */,
				isPassing : false
			}
		},
		mounted:function(){
			this.init()
			window.onresize =  () => {
				this.init()
			};
		},
		methods:{
			init: function(){
				this.maxWidth = this.$refs.dragVerify.clientWidth - this.$refs.handler.clientWidth
				if(this.isPassing){
					this.$refs.handler.style.left = this.maxWidth + 'px';
					this.$refs.progressBar.style.width = (this.maxWidth-this.height/2)+'px';
				}
			},
			dragStart: function(e){
				if(!this.isPassing) {
					this.isMoving = true;
					var handler = this.$refs.handler;
					this.x = (e.pageX||e.touches[0].pageX) - parseInt(handler.style.left.replace('px',''), 10);
				}
				document.onmousemove = ev => {
					let el = ev || event;
					this.dragMoving(el);
					return false;
				}
				document.onmouseup = ev => {
					let el = ev || event;
					this.dragFinish(el);
					document.onmousemove = null;
					return false;
				}
				e.stopPropagation();
				e.preventDefault();
			},
			dragMoving: function(e){
				if(this.isMoving && !this.isPassing){
					var _x = (e.pageX||e.touches[0].pageX) - this.x;
					var handler = this.$refs.handler;
					if(_x > 0 && _x <= this.maxWidth){
						handler.style.left = _x + 'px';
						this.$refs.progressBar.style.width = (_x+this.height/2)+'px';
					}else if(_x > this.maxWidth){  
						handler.style.left = this.maxWidth + 'px';
						this.$refs.progressBar.style.width = (this.maxWidth-this.height/2)+'px';
							this.passVerify();
					}
				}
			},
			dragFinish: function(e){
				if(this.isMoving && !this.isPassing){
					var _x = (e.pageX || e.changedTouches[0].pageX)- this.x;
					if(_x <(this.width - this.height)){
						this.$refs.handler.style.left = '0';
						this.$refs.progressBar.style.width = '0';
					}
					this.isMoving = false;
				}	
			},
			passVerify: function(){
				this.isPassing = true;
				this.isMoving = false;
				var handler = this.$refs.handler;
				handler.className += ' dv_handler_ok_bg';
				handler.children[0].className = this.successIcon;
				this.$refs.progressBar.style.background = this.completedBg;
				this.$refs.message.style.color = '#fff';
				this.$emit('passcallback');
			}
		}
	}
</script>
<style lang="scss" scoped>
	.drag_verify {
    position: relative;
    width: 100%;
    margin: 1rem 0;
    border-radius: .4rem;
    background-color: #e8e8e8;
    text-align: center;
    overflow: hidden;
  }
  .drag_verify .dv_handler {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 6rem;
    // border: 1px solid #ccc;
    cursor: move;
  }
  .drag_verify .dv_handler i {
    color: #666;
    font-size: 2rem;
  }
  .drag_verify .dv_handler_ok_bg {
    i{
      color: #5FB878;
    }
  }
  .drag_verify .dv_progress_bar {
    position: absolute;
    height: 34px;
    width: 0px;
    transition: background 2s ease-in;
  }
  .drag_verify .dv_text {
    position: absolute;
    top: 0px;
    color:#444;
    -moz-user-select: none;
    -webkit-user-select: none;
    user-select: none;
    -o-user-select:none;
    -ms-user-select:none;

  }
</style>